<script>
  import { _ } from '@sveltia/i18n';
  import { Toolbar, TruncatedText } from '@sveltia/ui';

  import CopyAssetsButton from '$lib/components/assets/toolbar/copy-assets-button.svelte';
  import DeleteAssetsButton from '$lib/components/assets/toolbar/delete-assets-button.svelte';
  import DownloadAssetsButton from '$lib/components/assets/toolbar/download-assets-button.svelte';
  import EditOptionsButton from '$lib/components/assets/toolbar/edit-options-button.svelte';
  import BackButton from '$lib/components/common/page-toolbar/back-button.svelte';
  import { goBack } from '$lib/services/app/navigation';
  import { overlaidAsset } from '$lib/services/assets';
  import { selectedAssetFolder } from '$lib/services/assets/folders';
  import { env } from '$lib/services/user/env.svelte';

  const assets = $derived(overlaidAsset.current ? [overlaidAsset.current] : []);
  const useButton = $derived(!env.isSmallScreen);
</script>

{#snippet overflowButtons()}
  <CopyAssetsButton {assets} {useButton} />
  <DownloadAssetsButton {assets} {useButton} />
  <DeleteAssetsButton
    {assets}
    buttonDescription={_('delete_assets', { values: { count: 1 } })}
    dialogDescription={_('confirm_deleting_this_asset')}
    onDelete={() => {
      goBack(`/assets/${selectedAssetFolder.current?.internalPath ?? '-/all'}`);
    }}
    {useButton}
  />
{/snippet}

<Toolbar variant="primary" aria-label={_('primary')}>
  <BackButton
    aria-label={_('cancel_editing')}
    useShortcut={true}
    onclick={() => {
      goBack(`/assets/${selectedAssetFolder.current?.internalPath ?? '-/all'}`);
    }}
  />
  <h2 role="none">
    <TruncatedText>
      <bdi>{overlaidAsset.current?.name}</bdi>
    </TruncatedText>
  </h2>
  {#if !env.isSmallScreen}
    {@render overflowButtons()}
  {/if}
  <EditOptionsButton asset={overlaidAsset.current}>
    {#snippet extraItems()}
      {#if env.isSmallScreen}
        {@render overflowButtons()}
      {/if}
    {/snippet}
  </EditOptionsButton>
</Toolbar>
